import * as R from 'ramda';
import React from 'react';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// forms
import { Fieldset2 } from '../../../forms';
// feature new-import
import * as C from '../constants';
import {
  tollChargeSourceOptions,
  importFromFileFieldSettings,
  defaultImportFromFileFields,
  importFromFileValidationSchema,
  fuelCardTransactionSourceOptions,
} from '../settings';
//////////////////////////////////////////////////

const enhance = compose(
  withFormik({
    mapPropsToValues: ({ initialValues }) => G.setInitialFormikValues(
      defaultImportFromFileFields,
      initialValues,
    ),
    validationSchema: importFromFileValidationSchema,
    handleSubmit: (values, { props }) => {
      const {
        type,
        file,
        source,
        roleGuids,
        contractGuid,
        cleanExistentRates,
        cleanExistentTrailers,
        trailerActivityListGuid,
        replaceExistentCompensations,
      } = values;

      let data = { type, file, [GC.FIELD_BRANCH_GUID]: G.getAmousCurrentBranchGuidFromWindow()};

      if (R.equals(type, C.IMPORT_TYPE_DRIVER)) {
        const parameters = { roleGuids };

        data = R.assoc('parameters', parameters, data);
      }

      if (R.includes(type, [C.IMPORT_TYPE_TOLL_CHARGE, C.IMPORT_TYPE_FUEL_CARD_TRANSACTION])) {
        const parameters = { source };

        data = R.assoc('parameters', parameters, data);
      }

      if (R.includes(type, C.CONTRACT_IMPORT_TYPES)) {
        const parameters = { contractGuid, cleanExistentRates };

        data = R.assoc('parameters', parameters, data);
      }

      if (R.equals(type, C.IMPORT_TYPE_COMPENSATION_GROUP)) {
        const parameters = { replaceExistentCompensations };

        data = R.assoc('parameters', parameters, data);
      }

      if (R.equals(type, C.IMPORT_TYPE_TRAILER_ACTIVITY_LIST_TRAILER)) {
        const parameters = { cleanExistentTrailers, trailerActivityListGuid };

        data = R.assoc('parameters', parameters, data);
      }

      props.submitAction(data);
    },
  }),
  pure,
);

export const ImportFromFile = (props) => {
  const { values, handleSubmit, driverRoleOptions } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset2
        {...G.getFormikProps(props)}
        fields={importFromFileFieldSettings}
        driverRoleOptions={driverRoleOptions}
        fieldsWrapperStyles={{ pt: 10, flexDirection: 'column' }}
        sourceOptions={G.ifElse(
          R.propEq(C.IMPORT_TYPE_FUEL_CARD_TRANSACTION, GC.FIELD_TYPE, values),
          fuelCardTransactionSourceOptions,
          tollChargeSourceOptions,
        )}
      />
      <FormFooter />
    </form>
  );
};

export default enhance(ImportFromFile);
